import { useTranslation, useLocation, Link } from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as LocaleContext from "../../i18n/I18nProvider.jsx";
import * as AnalyticsContext from "../../analytics/AnalyticsProvider.jsx";
import * as LocalizedPathsModule from "../../routing/localizedPaths.js";
import { Reveal } from "../Reveal.jsx";
import * as React from "react";
import { models } from "../../content/models.js";
import { sectionClass } from "../../config/sectionClasses.js";
import { sectionHeaderClass } from "../../config/sectionClasses.js";
import { HeroArrow } from "../hero/HeroActions.jsx";
var navButtonClass = "Models_navBtn__YH3GF";
var disabledNavButtonClass = "Models_navBtnDisabled__YH3GF";
var descriptionClass = "Models_modelDesc__YH3GF";
var pricingListClass = "Models_pricingList__YH3GF";
function ModelCard({ model: model, index: index, skipReveal: skipReveal }) {
  let { t: translate, i18n: i18n } = useTranslation(),
    { language: language } = (0, LocaleContext.useI18n)(),
    { pathname: pathname } = useLocation(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    d = i18n.language?.startsWith("zh"),
    p = (d ? model.name : model.nameEn).replace(/^Xiaomi /, ""),
    m = model.redirectUrl.startsWith("http"),
    h = m
      ? model.redirectUrl
      : (0, LocalizedPathsModule.BC)(model.redirectUrl, pathname, language);
  return (
    <Reveal delay={skipReveal ? 0 : 0.1 * index} skipReveal={skipReveal}>
      <Link
        to={h}
        target={m ? "_blank" : undefined}
        rel={m ? "noopener noreferrer" : undefined}
        className={"Models_modelCard__YH3GF"}
        onClick={() =>
          track("track", "home_model_click", {
            title: p,
          })
        }
      >
        <div className={"Models_modelCardHeader__YH3GF"}>
          <img src={model.image} alt={p} loading={"lazy"} />
        </div>
        <div className={"Models_modelCardBody__YH3GF"}>
          <div className={"Models_modelTitleRow__YH3GF"}>
            <h4 className={"Models_modelTitle__YH3GF"}>{p}</h4>
            {"offlineSoon" in model && model.offlineSoon && (
              <span className={"Models_modelTag__YH3GF"}>
                {translate("home.models.offlineSoon")}
              </span>
            )}
          </div>
          <p className={descriptionClass}>{d ? model.desc : model.descEn}</p>
          <div className={"Models_modelDivider__YH3GF"} />
          {model.pricing.length > 0 ? (
            <div className={pricingListClass}>
              {model.pricing.map((e) => (
                <div key={e.labelKey} className={"Models_pricingRow__YH3GF"}>
                  <span className={"Models_label__YH3GF"}>
                    {translate(e.labelKey)}
                  </span>
                  <span className={"Models_price__YH3GF"}>
                    {translate(e.priceKey)}
                    {"unitKey" in e &&
                      e.unitKey &&
                      ` / ${translate(e.unitKey)}`}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div className={pricingListClass}>
              <p
                className={descriptionClass}
                style={{
                  margin: 0,
                }}
              >
                {d
                  ? "限时体验（内测）已结束，\n正式商业版近期上线，敬请期待"
                  : "Limited beta has ended\nOfficial commercial release coming soon"}
              </p>
            </div>
          )}
        </div>
      </Link>
    </Reveal>
  );
}
function Models() {
  let getVisibleCount,
    subscribeResize,
    getServerVisibleCount,
    { t: translate } = useTranslation(),
    visibleCount =
      ((getVisibleCount = (0, React.useCallback)(() => {
        if ("u" < typeof window) return 2;
        let e = window.innerWidth;
        return e >= 768 ? 2 : 1;
      }, [])),
      (subscribeResize = (0, React.useCallback)(
        (e) => (
          window.addEventListener("resize", e),
          () => window.removeEventListener("resize", e)
        ),
        [],
      )),
      (getServerVisibleCount = (0, React.useCallback)(() => 2, [])),
      (0, React.useSyncExternalStore)(
        subscribeResize,
        getVisibleCount,
        getServerVisibleCount,
      )),
    pageCount = Math.max(1, models.length - visibleCount + 1),
    [activePage, setActivePage] = (0, React.useState)(0),
    [skipReveal, setSkipReveal] = (0, React.useState)(false),
    currentPage = Math.min(activePage, pageCount - 1),
    goToPage = (e) => {
      let t = Math.max(0, Math.min(e, pageCount - 1));
      if (!skipReveal) {
        (setSkipReveal(true),
          setTimeout(() => {
            setActivePage(t);
          }, 50));
        return;
      }
      setActivePage(t);
    },
    displayModels = (0, React.useMemo)(
      () =>
        1 === visibleCount
          ? models
          : [...models.slice(activePage), ...models.slice(0, activePage)],
      [activePage, visibleCount],
    );
  return (
    <section className={sectionClass}>
      <Reveal>
        <div className={`${sectionHeaderClass} Home_withAction__0iuvX`}>
          <h2>{translate("home.models.title")}</h2>
          <a
            href={"https://www.15token.win/keys"}
            className={"Models_viewAll__YH3GF"}
          >
            {translate("home.models.viewAll")}{" "}
            <HeroArrow stroke={"currentColor"} />
          </a>
        </div>
      </Reveal>
      <div className={"Models_modelCards__YH3GF"}>
        {displayModels.map((e, t) => (
          <ModelCard key={e.name} model={e} index={t} skipReveal={skipReveal} />
        ))}
      </div>
      <div className={"Models_carouselNav__YH3GF"}>
        <button
          type={"button"}
          className={`${navButtonClass} ${0 === currentPage ? disabledNavButtonClass : ""}`}
          onClick={() => goToPage(currentPage - 1)}
          aria-label={"Previous"}
        >
          <svg width={"16"} height={"16"} viewBox={"0 0 14 14"} fill={"none"}>
            <path
              d={
                "M12.834 7.584V6.417H3.4L5.704 4.113 4.879 3.288 1.167 7l3.712 3.713.825-.825L3.4 7.584h9.434z"
              }
              fill={"currentColor"}
            />
          </svg>
        </button>
        <div className={"Models_carouselDots__YH3GF"}>
          {Array.from(
            {
              length: pageCount,
            },
            (e, t) => (
              <button
                key={t}
                type={"button"}
                className={`Models_dot__YH3GF ${t === currentPage ? "Models_dotActive__YH3GF" : ""}`}
                onClick={() => goToPage(t)}
                aria-label={`Go to card ${t + 1}`}
              />
            ),
          )}
        </div>
        <button
          type={"button"}
          className={`${navButtonClass} ${currentPage === pageCount - 1 ? disabledNavButtonClass : ""}`}
          onClick={() => goToPage(currentPage + 1)}
          aria-label={"Next"}
        >
          <svg width={"16"} height={"16"} viewBox={"0 0 14 14"} fill={"none"}>
            <path
              d={
                "M1.166 7.584V6.417h9.434L8.296 4.113l.825-.825L12.833 7l-3.712 3.713-.825-.825 2.304-2.304H1.166z"
              }
              fill={"currentColor"}
            />
          </svg>
        </button>
      </div>
    </section>
  );
}
export {
  navButtonClass,
  disabledNavButtonClass,
  descriptionClass,
  pricingListClass,
  ModelCard,
  Models,
};
